import { ROUTE_PATHS } from '../routes/routePaths';

const ATTEMPTED_URL_STORAGE_KEY = 'notFound:attemptedUrl';

/**
 * Absolute app path for 404 (site root), e.g. `/not-found` — not under `/ENDUSER/`.
 */
export function getNotFoundUrlFromCurrentPath(): string {
  return ROUTE_PATHS.NOT_FOUND_PAGE;
}

/**
 * Best-effort — remembers the URL that's about to 404 before a redirect to the
 * generic /not-found path. Used both as the sole mechanism ahead of a HARD navigation
 * (`window.location.replace`, which — unlike a React Router `<Navigate state=...>` —
 * can't carry any state of its own) and as a fallback alongside router state for a
 * soft navigation that might be followed by another redirect (e.g. an auth guard)
 * that doesn't preserve it. Without this, the not-found page's error log would report
 * `/not-found` itself instead of the URL that actually failed to resolve.
 */
export function rememberNotFoundAttemptedUrl(url: string = window.location.href): void {
  try {
    sessionStorage.setItem(ATTEMPTED_URL_STORAGE_KEY, url);
  } catch {
    // Not fatal — the not-found page just falls back to its own current URL.
  }
}

/** One-shot read — clears the stored value so a later, unrelated 404 doesn't inherit it. */
export function getAndClearNotFoundAttemptedUrl(): string | null {
  try {
    const value = sessionStorage.getItem(ATTEMPTED_URL_STORAGE_KEY);
    sessionStorage.removeItem(ATTEMPTED_URL_STORAGE_KEY);
    return value;
  } catch {
    return null;
  }
}
